import { render, staticRenderFns } from "./LikesSystem.vue?vue&type=template&id=2577b4a6&"
import script from "./LikesSystem.vue?vue&type=script&lang=js&"
export * from "./LikesSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports